import { PrismicNextLink } from "@prismicio/next";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.FooterNavItemsSlice} FooterNavItemsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FooterNavItemsSlice>} FooterNavItemsProps
 * @type {import("react").FC<FooterNavItemsProps>}
 */
const FooterNavItems = ({ slice }) => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="flex flex-col gap-4 w-full md:w-fit"
    >
      {/* Label */}
      {isFilled.keyText(slice.primary.label) && (
        <div className="text-nav font-bold">{slice.primary.label}</div>
      )}

      {/* Liens */}
      {Array.isArray(slice.primary.link) && slice.primary.link.length > 0 && (
        <div className="flex flex-col gap-2">
          {slice.primary.link.map((linkItem, index) => (
            isFilled.link(linkItem) && (
              <PrismicNextLink
                key={index}
                field={linkItem}
                className="text-sm text-graphite hover:underline hover:decoration-green hover:decoration-1 hover:underline-offset-4 transition-all"
              />
            )
          ))}
        </div>
      )}
    </div>
  );
};

export default FooterNavItems;
